import { helper } from '@ember/component/helper';

// Returns the first truthy argument, falling back to the last one when none
// are. The fallback matters: `{{or count 0}}` must render "0" for an empty
// count, not the string "false".
export default helper(function or(args) {
  return args.find(Boolean) ?? args.at(-1);
});
